export default "__VITE_ASSET__SIM3WXUE__"